export default __webpack_public_path__ + "static/tarzana-logo-e752dc62337ad517e4a3aded98d3e653.png";